import { render, staticRenderFns } from "./SelectTagsField.vue?vue&type=template&id=9cbc3152&scoped=true"
import script from "./SelectTagsField.vue?vue&type=script&lang=js"
export * from "./SelectTagsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbc3152",
  null
  
)

export default component.exports